import { render, staticRenderFns } from "./franchise.vue?vue&type=template&id=22cb78a8&scoped=true"
import script from "./franchise.vue?vue&type=script&lang=js"
export * from "./franchise.vue?vue&type=script&lang=js"
import style0 from "./franchise.vue?vue&type=style&index=0&id=22cb78a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cb78a8",
  null
  
)

export default component.exports